import { useTranslation } from 'react-i18next';
import { type DummyWelcomePageEndpointSpecsFragment } from '../../../../../api/fragments/DummyWelcomePageEndpointSpecs';
import {
    CreateDummyWelcomePageEndpointDocument,
    type CreateDummyWelcomePageEndpointMutation,
    type CreateDummyWelcomePageEndpointMutationVariables,
} from '../../../../../api/mutations/createDummyWelcomePageEndpoint';
import {
    UpdateDummyWelcomePageEndpointDocument,
    type UpdateDummyWelcomePageEndpointMutation,
    type UpdateDummyWelcomePageEndpointMutationVariables,
} from '../../../../../api/mutations/updateDummyWelcomePageEndpoint';
import { type DummyWelcomePageSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import { type EndpointImplementation } from './types';

const implementation: EndpointImplementation<DummyWelcomePageEndpointSpecsFragment, DummyWelcomePageSettings> = {
    getTitle: t => t('routerDetails:endpoints.DummyWelcomePageEndpoint.title'),
    ViewPanelComponent: null,
    getIsPrivate: () => false,
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <InputField {...t('routerDetails:endpoints.fields.pathname', { returnObjects: true })} name="pathname" />
        );
    },
    getFormInitialValues: endpoint => ({
        pathname: endpoint.pathname,
    }),
    submitCreation: (apolloClient, routerId, values) =>
        apolloClient.mutate<CreateDummyWelcomePageEndpointMutation, CreateDummyWelcomePageEndpointMutationVariables>({
            mutation: CreateDummyWelcomePageEndpointDocument,
            variables: { routerId, settings: values },
        }),
    submitUpdate: (apolloClient, routerId, endpointId, values) =>
        apolloClient.mutate<UpdateDummyWelcomePageEndpointMutation, UpdateDummyWelcomePageEndpointMutationVariables>({
            mutation: UpdateDummyWelcomePageEndpointDocument,
            variables: { routerId, endpointId, settings: values },
        }),
};

export default implementation;
